export default "__VITE_ASSET__3e3e24ce__"